var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericButton',_vm._g({attrs:{"theme":_vm.theme,"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('div',{class:( _obj = {}, _obj[_vm.icon] = true, _obj['inline-block !ml-2.5 !opacity-100 !w-auto text-xl leading-none align-middle'] =  _vm.alwaysShowIcon, _obj['animate-spin'] =  _vm.shouldSpinIcon, _obj )})],2)}
var staticRenderFns = []

export { render, staticRenderFns }